module.exports = __webpack_public_path__ + "static/img/evaluation_MBTI_2.35ff1182.jpg";